<script>
export default {
  name: "blackWarehouseIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.00016 3.43343L2.66683 5.56676V12.6668H4.00016V8.66676C4.00016 8.3001 4.13072 7.98621 4.39183 7.7251C4.65294 7.46399 4.96683 7.33343 5.3335 7.33343H10.6668C11.0335 7.33343 11.3474 7.46399 11.6085 7.7251C11.8696 7.98621 12.0002 8.3001 12.0002 8.66676V12.6668H13.3335V5.56676L8.00016 3.43343ZM1.3335 12.6668V5.56676C1.3335 5.28899 1.4085 5.03899 1.5585 4.81676C1.7085 4.59454 1.91127 4.43343 2.16683 4.33343L7.50016 2.2001C7.65572 2.13343 7.82238 2.1001 8.00016 2.1001C8.17794 2.1001 8.34461 2.13343 8.50016 2.2001L13.8335 4.33343C14.0891 4.43343 14.2918 4.59454 14.4418 4.81676C14.5918 5.03899 14.6668 5.28899 14.6668 5.56676V12.6668C14.6668 13.0334 14.5363 13.3473 14.2752 13.6084C14.0141 13.8695 13.7002 14.0001 13.3335 14.0001H10.6668V8.66676H5.3335V14.0001H2.66683C2.30016 14.0001 1.98627 13.8695 1.72516 13.6084C1.46405 13.3473 1.3335 13.0334 1.3335 12.6668ZM6.00016 14.0001V12.6668H7.3335V14.0001H6.00016ZM7.3335 12.0001V10.6668H8.66683V12.0001H7.3335ZM8.66683 14.0001V12.6668H10.0002V14.0001H8.66683Z"
      fill="#7A889B"
    />
  </svg>
</template>

<style scoped></style>
